import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CompoApp } from '../CompoApp';
import { UrlBuilder } from '../../models/frontend_entities/UrlBuilder';
import Constants from '../../Constants';
import { PagedNotificationEventModel } from '../../models/notification_event/paged-notification-event.model';
import { Observable } from 'rxjs';
import { NotificationByUserModel } from '../../models/notification_event/notification-by-user.model';
import { NotificationEventType } from '../../models/notification_event/notification-event-type.model';
import { take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class NotificationEventRequestService {

  private http: HttpClient = inject(HttpClient);
  private app: CompoApp = inject(CompoApp);


  fetchPageByUserId(userId: string, offset: number, size: number): Observable<PagedNotificationEventModel> {
    const url = new UrlBuilder(Constants.URLS.notificationEvent.fetchPageByUser
      .replace('{userId}', userId.toString()))
      .param('accessMode', this.app.data.getAccessMode())
      .param('offset', offset)
      .param('size', size)
      .build();

    return this.http.get<PagedNotificationEventModel>(url).pipe(take(1));
  }

  fetchAllUnprocessed(userId: string): Observable<NotificationByUserModel[]> {
    const url = new UrlBuilder(Constants.URLS.notificationEvent.fetchAllUnprocessed
      .replace('{userId}', userId.toString()))
      .param('accessMode', this.app.data.getAccessMode())
      .build();

    return this.http.get<NotificationByUserModel[]>(url);
  }

  processNotification(userId: string, notificationId: string): Observable<void> {
    const url = new UrlBuilder(Constants.URLS.notificationEvent.processNotification
      .replace('{userId}', userId.toString())
      .replace('{notificationId}', notificationId.toString()))
      .param('accessMode', this.app.data.getAccessMode())
      .build();

    return this.http.put<void>(url, null).pipe(take(1));
  }

  processMultipleNotifications(userId: string, notifications: Set<string>): Observable<void> {
    const url = new UrlBuilder(Constants.URLS.notificationEvent.processMultipleNotifications
      .replace('{userId}', userId.toString()))
      .param('accessMode', this.app.data.getAccessMode())
      .build();

    return this.http.put<void>(url, [...notifications]).pipe(take(1));
  }

  fetchAllTypes(): Observable<NotificationEventType[]> {
    const url = new UrlBuilder(Constants.URLS.notificationEvent.fetchAllTypes)
      .param('accessMode', this.app.data.getAccessMode())
      .build();

    return this.http.get<NotificationEventType[]>(url).pipe(take(1));
  }

  deleteNotificationForUser(notificationId: string): Observable<void> {
    const url = new UrlBuilder(Constants.URLS.notificationEvent.delete
      .replace('{notificationId}', notificationId.toString()))
      .param('accessMode', this.app.data.getAccessMode())
      .build();
    return this.http.delete<void>(url).pipe(take(1));
  }

}
